export default "__VITE_ASSET__B$68FVjc__"